import { render, staticRenderFns } from "./SongEdit.vue?vue&type=template&id=ba45d578&scoped=true"
import script from "./SongEdit.vue?vue&type=script&lang=ts"
export * from "./SongEdit.vue?vue&type=script&lang=ts"
import style0 from "./SongEdit.vue?vue&type=style&index=0&id=ba45d578&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba45d578",
  null
  
)

export default component.exports